// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export default {
    "dirty": true,
    "raw": "b9f8fc8-dirty",
    "hash": "b9f8fc8",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "b9f8fc8-dirty",
    "semverString": null
};
/* tslint:enable */
